import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPeriodico = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1000px",
	height: "1000px",
	viewBox: "0 0 1000 1000",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Group 8" }), /* @__PURE__ */ _jsx("g", {
		id: "10.-Checker",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group-8",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "icon_Background",
				x: 0,
				y: 0,
				width: 1e3,
				height: 1e3
			}), /* @__PURE__ */ _jsxs("g", {
				id: "periodico",
				transform: "translate(388.888889, 277.777778)",
				children: [/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle-Copy-7",
					stroke: "#0056C1",
					strokeWidth: 28,
					x: 14,
					y: 152.888889,
					width: 194.222222,
					height: 305.333333
				}), /* @__PURE__ */ _jsx("polygon", {
					id: "_",
					fill: "#424548",
					fillRule: "nonzero",
					points: "222.222222 27.7777778 222.222222 0 3.94745964e-13 0 3.94745964e-13 27.7777778"
				})]
			})]
		})
	})]
});
export default SvgPeriodico;
